import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = [
  'translatedVideoView',
  'lipSyncVideoView',
  'trialPreviewViewed',
  'trialPreviewEditTranslationButtonClick',
  'trialPreviewPlayingActiveTab',
  'trialPreviewPausedActiveTab',
] as const;

export const videoPlayerEvents = getMappedEvents([...EVENTS], {
  shouldSendRaskTTSData: true,
  shouldSendSubscriptionData: true,
});
